module.exports = __webpack_public_path__ + "img/stuff-to-do-1.96f0a027.png";